import InformationIcon from './component'

export default InformationIcon
